// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExamAnswer_wrapper","no-text-answer":"ExamAnswer_no-text-answer","noTextAnswer":"ExamAnswer_no-text-answer"};